import "../css/app.css";

function localizeTimes() {
  document.querySelectorAll("time[data-utc]").forEach(function (el) {
    var date = new Date(el.getAttribute("data-utc"));
    if (isNaN(date)) return;

    el.textContent = date.toLocaleString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  });
}

function pad(n) {
  return String(n).padStart(2, "0");
}

function initReleaseForm() {
  var status = document.getElementById("release_status");
  var dateField = document.getElementById("release_released_at_field");
  var dateInput = document.getElementById("release_released_at");
  var form = status && status.form;

  if (!status || !dateField) return;

  var sync = function () {
    dateField.style.display = status.value === "released" ? "" : "none";
  };
  status.addEventListener("change", sync);
  sync();

  if (dateInput && dateInput.dataset.utc) {
    var d = new Date(dateInput.dataset.utc);
    if (!isNaN(d)) {
      dateInput.value = d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" +
        pad(d.getDate()) + "T" + pad(d.getHours()) + ":" + pad(d.getMinutes());
    }
  }

  if (form && dateInput) {
    form.addEventListener("submit", function () {
      if (!dateInput.value) return;
      var local = new Date(dateInput.value);
      if (isNaN(local)) return;
      dateInput.value = local.getUTCFullYear() + "-" + pad(local.getUTCMonth() + 1) + "-" +
        pad(local.getUTCDate()) + "T" + pad(local.getUTCHours()) + ":" + pad(local.getUTCMinutes());
    });
  }
}

localizeTimes();
initReleaseForm();
